/**
 * データを日付フィルタリング
 *
 * @param {Array<ReservationRecord>} records
 * @param {Array<moment>} days
 */
export default function (records, days) {
    const validDays = days.map((date) => {
        return date.format('YYYYMMDD');
    });

    return records.filter((record) => {
        return validDays.some((dateString) => {
            return dateString === record.date;
        });
    });
}
